/**
 * 管理员按用户查看看板时附加 owner_user_id（后端仅管理员有效）
 * @param {Record<string, unknown>} params
 * @param {number|null|undefined} ownerUserId
 */
export function withOwnerUserId(params, ownerUserId) {
  if (ownerUserId == null || ownerUserId === undefined) {
    return params;
  }
  return { ...params, owner_user_id: ownerUserId };
}

/**
 * 导出等严格归属场景：仅保留显式 owner_user_id 归属的数据
 * @param {Record<string, unknown>} params
 * @param {boolean} strictOwnerOnly
 */
export function withStrictOwnerOnly(params, strictOwnerOnly) {
  if (!strictOwnerOnly) {
    return params;
  }
  return { ...params, strict_owner_only: true };
}
